import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step8 } from '../../../../shared/models/component-messages/mapaIN/step8';
import { ConformiteFournitures } from '../models/ConformiteFournitures';
@Component({
  selector: 'app-conformite-fournitures',
  templateUrl: './conformite-fournitures.component.html'
})
export class ConformiteFournituresComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'ConformiteFournitures';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() conformiteFournitures: ConformiteFournitures;

  public step8 = new Step8();

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

